import React, { useState, useEffect, useContext, Dispatch, SetStateAction } from "react";
import InsightFiltersViewModel from "../../ViewModels/InsightFiltersViewModel";
import { MsalContext } from "../../../Contexts/MsalContext"
import SelectFilterContainer from "../GenericFilters/Select/SelectFilterContainer";

interface IChannelFilterContainerProps {
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
}

export default function ChannelFilterContainer({ filters, setFilters }: IChannelFilterContainerProps) {
    const { msalFetch } = useContext(MsalContext);
    const [options, setOptions] = useState<string[]>([])

    useEffect(() => {
        msalFetch(`api/User/GetChannelList?client=${filters.client}`)
            .then(response => response.json())
            .then(json => {
                setOptions(json)
            })
    }, [filters.client])

    return (
        <>
            <SelectFilterContainer
                filters={filters}
                setFilters={setFilters}
                name='channel'
                label='Channel'
                options={options} />
        </>
    );
};